import React, { useState, useEffect } from 'react';
import { useAuth } from './AuthContext';

// Custom replacement for Convex's Authenticated component
export const Authenticated: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  
  if (isLoading) {
    return null;
  }
  
  return isAuthenticated ? <>{children}</> : null;
};

// Custom replacement for Convex's Unauthenticated component
export const Unauthenticated: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  
  if (isLoading) {
    return null;
  }
  
  return !isAuthenticated ? <>{children}</> : null;
};

// Custom replacement for Convex's AuthLoading component with delayed display
export const AuthLoading: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isLoading } = useAuth();
  const [showLoading, setShowLoading] = useState(false);
  
  useEffect(() => {
    // Only show loading indicator if loading takes more than 500ms
    let timer: number | null = null;
    
    if (isLoading) {
      timer = window.setTimeout(() => {
        setShowLoading(true);
      }, 500);
    } else {
      setShowLoading(false);
    }
    
    return () => {
      if (timer) window.clearTimeout(timer);
    };
  }, [isLoading]);
  
  // Only show loading UI if we're still loading after the delay
  return (showLoading && isLoading) ? <>{children}</> : null;
}; 